var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.GetRequiredSegmentCount(_vm.message).usedChars)+" / "+_vm._s(_vm.GetRequiredSegmentCount(_vm.message).totalChars)+" ( "+_vm._s(_vm.GetRequiredSegmentCount(_vm.message).segmentCount)+" Chargeable SMS) ")])}
var staticRenderFns = []

export { render, staticRenderFns }